export * from './room/room-resource.page';
export * from './rooms/room-resources.page';
export * from './trainer/trainer-resource.page';
export * from './trainers/trainer-resources.page';
export * from './zoom/zoom-resource.page';
export * from './zooms/zoom-resources.page';
